import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const PeoplesoftReaderForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;
  const isGet = form.watch('properties.httpMethod') === 'GET';

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="peoplesoftReaderFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors?.name?.message}
      />
      <FormField
        controlId="peoplesoftReaderFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors?.type?.message}
      />
      <FormField
        controlId="peoplesoftReaderFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="peoplesoftReaderFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.parameterizedBy?.message}
      />
      <FormField
        controlId="peoplesoftReaderFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.format?.message}
      />
      <FormField
        controlId="peoplesoftReaderFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.connectionKey?.message}
      />
      <FormField
        controlId="peoplesoftReaderFormPaginationType"
        label="paginationType"
        name="properties.paginationType"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        error={errors?.properties?.paginationType?.message}
      >
        <option value="QueryString">Query String</option>
        <option value="RequestBody">Request Body</option>
        <option value="Stream">Stream</option>
      </FormField>
      <FormField
        controlId="peoplesoftReaderFormHttpMethod"
        label="httpMethod"
        name="properties.httpMethod"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        placeholder="Select HTTP Method"
        error={errors?.properties?.httpMethod?.message}
      >
        <option value="">Select HTTP Method</option>
        <option value="GET">GET</option>
        <option value="POST">POST</option>
        <option value="PUT">PUT</option>
        <option value="DELETE">DELETE</option>
      </FormField>
      <FormField
        controlId="peoplesoftReaderFormUrl"
        label="url"
        name="properties.url"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter URL"
        error={errors?.properties?.url?.message}
      />
      <FormField
        controlId="peoplesoftReaderFormToken"
        label="token"
        name="properties.token"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter Token"
        error={errors?.properties?.token?.message}
      />
      <FormField
        controlId="peoplesoftReaderFormAcceptInvalidCerts"
        label="acceptInvalidCerts"
        name="properties.acceptInvalidCerts"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
        error={errors?.properties?.acceptInvalidCerts?.message}
      />
      <FormField
        controlId="peoplesoftReaderFormHeaderJson"
        label="headerJson"
        name="properties.headerJson"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.JSON}
        placeholder="Enter Header JSON"
        rows={10}
        error={errors?.properties?.headerJson?.message}
      />
      {!isGet && (
        <FormField
          controlId="peoplesoftReaderFormBody"
          label="body"
          name="properties.body"
          control={formControl}
          fieldComponentType={FORM_FIELD_TYPES.JSON}
          placeholder="Enter Body"
          error={errors?.properties?.body?.message}
          disabled={isGet}
        />
      )}
      <FormField
        controlId="peoplesoftReaderFormQueryString"
        label="queryString"
        name="properties.queryString"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SPARKQL}
        placeholder="Enter Query String"
        rows={10}
        error={errors?.properties?.queryString?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default PeoplesoftReaderForm;
